import * as React from 'react'
import {definedContextValueHookFactory} from '@oc/hooks'
import {OcGenericStepDialogState} from './OcGenericStepDialogState'
import {useEventBusChannel} from '@oc/shell-core'
import {OcGenericStepDialogEvents} from './OcGenericStepDialogEvents'

const OcGenericStepDialogStateContext = React.createContext<OcGenericStepDialogState | null>(null)

export const useOcGenericStepDialogStateContext = definedContextValueHookFactory(
    OcGenericStepDialogStateContext,
    'OcGenericStepDialogStateContext'
)

export function OcGenericStepDialogStateContextProvider({
    children,
    dialogId
}: React.PropsWithChildren<{dialogId: string}>) {
    const eventBusChannel = useEventBusChannel<OcGenericStepDialogEvents>()
    const [state] = React.useState(() => new OcGenericStepDialogState(eventBusChannel, dialogId))
    state.useOcGenericStepDialogChangeStepEvent()
    state.useOcGenericStepDialogUpdateConfigurationEvent()
    state.useOcGenericStepDialogToggleButtonsEvent()
    state.useOcGenericStepDialogUpdateStepEvent()

    return <OcGenericStepDialogStateContext.Provider value={state}>{children}</OcGenericStepDialogStateContext.Provider>
}
